import { AppShell, type NavEntry } from '@cyntox/common/AppShell';

// The frame (sidebar, drawer, footer, version, help, links to the other apps)
// is shared by every Cyntox site. This is Fleet's menu: the register, then the
// shops units go to, then the to-do list. There is no Import screen: Fleet is where vehicles are kept
// now, and a list that still has to be loaded is loaded for Marsha, previewed first.

const NAV: NavEntry[] = [
  { to: '/register', label: 'Register', resource: 'vehicles' },
  { to: '/shops', label: 'Shops', resource: 'vehicles' },
  { to: '/todo', label: 'To-do', resource: 'vehicles' },
];

export function Shell() {
  return (
    <AppShell
      app="fleet"
      badge="FLEET"
      nav={NAV}
      version={__APP_VERSION__}
      helpLabel="How to use Fleet"
      // Fleet access is not by location yet; units now carry an Admin region, which it can be scoped by.
      locationName={(code) => code}
      noLocationLabel="No access"
      allLocationsLabel="Every unit"
    />
  );
}
